export const DISTRICTS = ["adar", "carmel_center", "other"] as const;
export type District = (typeof DISTRICTS)[number];

export const INTERESTS = ["boardgames", "run", "cafe", "movie", "walk"] as const;
export type Interest = (typeof INTERESTS)[number];

export const LANGUAGES = ["ru", "he", "en", "uk"] as const;
export type Language = (typeof LANGUAGES)[number];

export const EVENT_FORMATS = [
  "cafe",
  "run",
  "boardgames",
  "movie",
  "walk",
  "sport",
  "music",
  "food",
  "drinks",
  "beach",
  "lecture",
  "party",
  "art",
  "nature",
  "other",
] as const;
export type EventFormat = (typeof EVENT_FORMATS)[number];

export const EVENT_STATUSES = ["scheduled", "cancelled", "completed"] as const;
export type EventStatus = (typeof EVENT_STATUSES)[number];

export const RSVP_STATUSES = ["going", "cancelled"] as const;
export type RsvpStatus = (typeof RSVP_STATUSES)[number];

export const CITIES = [
  "jerusalem",
  "tel_aviv",
  "haifa",
  "rishon_lezion",
  "petah_tikva",
  "ashdod",
  "netanya",
  "beer_sheva",
  "bnei_brak",
  "holon",
  "ramat_gan",
  "ashkelon",
  "rehovot",
  "bat_yam",
  "beit_shemesh",
  "kfar_saba",
  "herzliya",
  "hadera",
  "modiin",
  "lod",
  "ramla",
  "raanana",
  "nahariya",
  "eilat",
  "tiberias",
  "nazareth",
  "akko",
] as const;
export type City = (typeof CITIES)[number];

export const REVIEW_STATUSES = ["pending", "approved", "rejected"] as const;
export type ReviewStatus = (typeof REVIEW_STATUSES)[number];

export const POINT_REASONS = [
  "signup_bonus",
  "event_attended",
  "streak_bonus",
  "referral_join",
  "referral_active",
  "reward_redeem",
  "manual_adjust",
  "attendee_verified",
] as const;
export type PointReason = (typeof POINT_REASONS)[number];

export const REWARD_KINDS = ["premium_days", "partner_voucher"] as const;
export type RewardKind = (typeof REWARD_KINDS)[number];

// Points economy — anchor: 1 month premium = 100 points (see rewards_catalog,
// repriced in migration 0009). Signup bonus = exactly one free month.
export const POINTS = {
  SIGNUP_BONUS: 100,
  EVENT_ATTENDED: 15,
  STREAK_3_PER_MONTH: 20,
  REFERRAL_JOIN: 5,        // both referrer and referee
  REFERRAL_ACTIVE: 30,     // both, after referee attends first event
  HOST_PER_GUEST: 5,       // host earns this per verified (scanned) guest
  MAX_REFERRALS_PER_DAY: 10,
} as const;
